// extracted by mini-css-extract-plugin
export default {"iconSection":"commentButton_iconSection__MhI+y","button_icon":"commentButton_button_icon__EIKEo"};